module.exports = __webpack_public_path__ + "static/media/Maji_en.8b558055.gif";